import { NgClass } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, NgZone, OnDestroy, Output, signal, inject, CUSTOM_ELEMENTS_SCHEMA, ElementRef, ViewChild, OnInit } from '@angular/core';
import { ensureSwiperRegistered } from '@shared/loaders/swiper-loader';
import { Subscription } from 'rxjs';
import { SwiperOptions } from 'swiper/types';


@Component({
  selector: 'app-auth-slider-presenter',
  imports: [
    NgClass
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './auth-slider-presenter.component.html',
  styleUrl: './auth-slider-presenter.component.scss'
})
export class AuthSliderPresenterComponent implements OnInit, AfterViewInit, OnDestroy {
  private zone = inject(NgZone);

  @ViewChild('auth_slider') auth_slider!: ElementRef<any>

  activeSlideIndex = signal(0);
  @Output() onRegister: EventEmitter<void> = new EventEmitter<void>();
  @Output() onLogin: EventEmitter<void> = new EventEmitter<void>();
  sub: Subscription = new Subscription();


  slides = [
    { img: 'https://cloud.behkhaan.ir/assets/images/auth-slider/book-shelf.svg', title: 'قفسه‌های کتاب', description: 'آمار کتاب‌های خوانده و نخوانده‌ات را داشته باش.' },
    { img: 'https://cloud.behkhaan.ir/assets/images/auth-slider/Writing-about-book.svg', title: 'نوشتن دربارهٔ کتاب‌ها', description: 'از کتاب‌ها بنویس و یادداشت دیگران را هم بخوان.' },
    { img: 'https://cloud.behkhaan.ir/assets/images/auth-slider/various-challenges.svg', title: 'چالش‌های متنوع', description: 'کتاب خواندن را به عادت هرروزه‌ات تبدیل کن.ما هم اینجاییم که کمک کنیم.' }
  ];

  async ngOnInit() {
    await ensureSwiperRegistered();
  }

  ngAfterViewInit(): void {
    const swiperEl = this.auth_slider.nativeElement;
    Object.assign(swiperEl, {
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      loop: true,
      speed: 1000,
      slidesPerView: 1,
      observer: true,
      centeredSlidesBounds: true,
    } as SwiperOptions);
    swiperEl.initialize();
    this.auth_slider.nativeElement.addEventListener('swiperslidechange', () => {
      this.onSlideChange();
    });
  }

  onSlideChange() {
    this.zone.run(() => {
      const currentIndex = this.auth_slider.nativeElement.swiper.realIndex;
      this.activeSlideIndex.set(currentIndex);
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
